<div class="form-group item-long" [ngClass]="required ? 'required' : ''">
  <label for="keySkills" *ngIf="dropdownLabel">{{ dropdownLabel }}</label>
  <ng-select
    id="keySkills"
    [items]="list"
    [bindLabel]="labelToBind"
    [bindValue]="valueToBind"
    [multiple]="true"
    [maxSelectedItems]="maxItems"
    [closeOnSelect]="false"
    [(ngModel)]="selectedOption"
    (ngModelChange)="fnSetOption()"
    [disabled]="isDisabled"
  >
    <ng-template ng-label-tmp let-item="item">
      <div class="selected-items">
        {{ item.name }}
      </div>
    </ng-template>
    <ng-template
      ng-option-tmp
      let-item="item"
      let-item$="item$"
      let-index="index"
    >
      <div class="d-flex align-items-center">
        <input
          type="checkbox"
          [ngModel]="item$.selected"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="item$.selected = $event"
        />
        &nbsp;{{ item.name }}
      </div>
    </ng-template>
  </ng-select>
  <div
    class="text-warning"
    *ngIf="this.selectedOption && this.selectedOption.length >= maxItems"
  >
    {{ invalidMessage }}
  </div>
</div>
